/* Native transparent video playback: no WebGL scene or per-frame JS work. */
(() => {
  if (window.AKTransparentRotation) return;
  const instances = new WeakMap();
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome|Chromium|CriOS|Edg|OPR|Firefox|FxiOS/.test(navigator.userAgent);
  function mount(root = document) {
    const cleanups = [];
    root.querySelectorAll('video[data-ak-rotation]').forEach(video => {
      if (instances.has(video)) return;
      const box = video.closest('[data-ak-rotation-box]');
      const loader = box.querySelector('[data-ak-rotation-loader]');
      const media = matchMedia(video.dataset.akRotationMedia || 'all');
      let visible = false, started = false, disposed = false, finishing = false;
      const ready = () => {
        if (disposed || finishing) return;
        finishing = true;
        const completed = window.AKLoaderMotion?.finish(loader) || Promise.resolve();
        completed.then(() => {
          if (disposed) return;
          box.classList.add('is-model-ready');
          loader?.remove();
        });
      };
      const fallback = () => { box.classList.add('is-rotation-fallback'); ready(); };
      const playing = () => { box.classList.remove('is-rotation-fallback'); ready(); };
      const sync = () => {
        if (disposed) return;
        if (!media.matches || !visible || document.hidden || reduced.matches) {
          video.pause();
          if (reduced.matches) fallback();
          return;
        }
        if (started) video.play().catch(fallback);
      };
      const load = () => {
        if (started || !media.matches || disposed) return;
        if (reduced.matches) { fallback(); return; }
        started = true;
        // Chromium can decode some HEVC files without their alpha layer.
        // Route WebKit to HEVC-alpha and Chromium/Firefox to VP9-alpha.
        video.src = (isSafari || isIOS) ? video.dataset.akRotationHevc : video.dataset.akRotationWebm;
        video.load();
        sync();
      };
      video.muted = true;
      video.addEventListener('loadeddata', ready);
      video.addEventListener('playing', playing);
      video.addEventListener('error', fallback);
      const preload = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) load();
      }, {rootMargin:'400px'});
      const playback = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) load();
        sync();
      });
      const changed = () => { if (visible) load(); sync(); };
      preload.observe(video); playback.observe(video);
      document.addEventListener('visibilitychange', sync);
      media.addEventListener('change', changed);
      reduced.addEventListener('change', changed);
      const cleanup = () => {
        disposed = true;
        preload.disconnect(); playback.disconnect(); video.pause();
        video.removeEventListener('loadeddata', ready);
        video.removeEventListener('playing', playing);
        video.removeEventListener('error', fallback);
        document.removeEventListener('visibilitychange', sync);
        media.removeEventListener('change', changed);
        reduced.removeEventListener('change', changed);
        video.removeAttribute('src'); video.load();
        instances.delete(video);
      };
      instances.set(video, cleanup); cleanups.push(cleanup);
    });
    return () => cleanups.forEach(cleanup => cleanup());
  }
  window.AKTransparentRotation = {mount};
  const init = () => mount();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
